import api from './api';

// Admin user management. All endpoints are admin-gated on the backend
// (requireAuth + requireAdmin) and scoped to this deployment's practice DB.
const userService = {
  list: () => api.get('/users/list').then((r) => r.data.users || []),
  create: (payload) => api.post('/users/create', payload).then((r) => r.data),
  update: (payload) => api.put('/users/update', payload).then((r) => r.data),
  remove: (uid) => api.delete(`/users/delete/${uid}`).then((r) => r.data),
};

export default userService;
